import { useNavigate } from 'react-router-dom';
import { React, clsx } from '../../barrelFiles/basicBarrelFile';

/**
 * @param { boolean } enableBreadCrumb - stores if grapesJs's  view annotations command is active
 * @param { number } selectedProject - stores index of user's selected project
 * @returns component with a button that, when enableBreadcrumb is false navigates to deploy_page page, else button's action is disabled.
 */
const AuthenticateButton = ({ enableBreadCrumb, selectedProject }) => {
  const navigate = useNavigate();
  if (!enableBreadCrumb)
    // Check if view annotations command is active
    // Disabled deploy button
    return (
      <div
        className={clsx('fas', 'fa-shield')}
        style={{ marginRight: '1vw', marginTop: '0.5vw', transform: 'translate(-50%, 0)' }}
      />
    );

  // Button that navigates to deploy_page page
  return (
    <div
      data-tooltip="Authentication"
      data-tooltip-pos="bottom"
      className={clsx('cleanCssButton', 'fas', 'fa-shield', 'teamselector')}
      style={{ marginRight: '1vw', marginTop: '0.5vw' }}
      onClick={() => navigate('/authentication_page', { state: { selectedProject } })}
      aria-hidden="true"
    />
  );
};
export default AuthenticateButton;
